// Pagina publica /privacidade — Politica de Privacidade do catalogo. Sem login.
// Onda Catalogo Fase 3. Rascunho — revisao do Ruan pendente.
import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { RodapeCatalogo } from './RodapeCatalogo';

const ATUALIZADO_EM = '16 de maio de 2026';

function Secao({ titulo, children }: { titulo: string; children: React.ReactNode }) {
  return (
    <section className="mt-5">
      <h2 className="text-base font-semibold" style={{ color: '#b45309' }}>
        {titulo}
      </h2>
      <div className="mt-1.5 text-sm leading-relaxed text-gray-700 space-y-2">{children}</div>
    </section>
  );
}

export function CatalogoPublicoPrivacidade() {
  useEffect(() => {
    document.title = 'Politica de Privacidade — FIODECOBRE';
  }, []);

  return (
    <div
      className="catalogo-publico-root"
      style={{ minHeight: '100vh', backgroundColor: '#f7f7f7', color: '#111' }}
    >
      {/* Header com voltar */}
      <header style={{ backgroundColor: '#b45309', color: '#fff' }} className="sticky top-0 z-30 shadow">
        <div className="max-w-3xl mx-auto px-3 py-3 flex items-center gap-3">
          <Link
            to="/catalogo"
            className="inline-flex items-center justify-center rounded-full"
            style={{ width: 36, height: 36, backgroundColor: 'rgba(255,255,255,0.15)' }}
          >
            <ArrowLeft size={18} />
          </Link>
          <div className="flex-1 min-w-0">
            <h1 className="text-sm font-medium opacity-90 truncate">Fio de Cobre</h1>
            <p className="text-xs opacity-75 truncate">Politica de Privacidade</p>
          </div>
        </div>
      </header>

      <main className="max-w-3xl mx-auto px-3 py-4">
        <div
          className="rounded-lg shadow-sm border border-gray-200 px-4 sm:px-6 py-5"
          style={{ backgroundColor: '#fff' }}
        >
          <h1 className="text-xl font-bold text-gray-900">Politica de Privacidade</h1>
          <p className="mt-1 text-xs text-gray-500">Ultima atualizacao: {ATUALIZADO_EM}</p>

          <p className="mt-4 text-sm leading-relaxed text-gray-700">
            Esta politica explica como a Fio de Cobre trata as informacoes de quem
            acessa o catalogo digital disponivel em fiodecobre.com.br/catalogo. Levamos
            a sua privacidade a serio e seguimos a Lei Geral de Protecao de Dados
            (Lei n. 13.709/2018 — LGPD).
          </p>

          <Secao titulo="1. Quem e o responsavel">
            <p>
              O responsavel pelo tratamento dos seus dados e a{' '}
              <strong>FIO DE COBRE LTDA</strong>, CNPJ 49.762.154/0001-00, com
              estabelecimento na Av. Rio da Prata, 920, Setor Montes Belos, Sao Luis de
              Montes Belos / GO, CEP 76052-201.
            </p>
            <p>
              Contato para assuntos de privacidade:{' '}
              <a
                href="mailto:atendimento@fiodecobre.com.br"
                className="font-medium"
                style={{ color: '#b45309' }}
              >
                atendimento@fiodecobre.com.br
              </a>
              .
            </p>
          </Secao>

          <Secao titulo="2. Quais informacoes coletamos">
            <p>
              O catalogo digital e uma vitrine de consulta:{' '}
              <strong>nao exige cadastro, login nem senha</strong> para navegar.
            </p>
            <p>Coletamos informacoes apenas em duas situacoes:</p>
            <ul className="list-disc pl-5 space-y-1">
              <li>
                <strong>Dados que voce nos envia:</strong> ao clicar em "Falar pelo
                WhatsApp" ou ao usar a opcao de ser avisado quando um produto voltar ao
                estoque, voce nos informa o seu numero de WhatsApp e o conteudo da
                mensagem.
              </li>
              <li>
                <strong>Dados de navegacao:</strong> informacoes tecnicas e anonimas,
                como tipo de dispositivo, paginas visitadas e produtos consultados,
                que podem ser coletadas por ferramentas de medicao de audiencia.
              </li>
            </ul>
            <p>
              Nao coletamos dados sensiveis e nao solicitamos CPF, endereco ou dados de
              pagamento pelo catalogo.
            </p>
          </Secao>

          <Secao titulo="3. Para que usamos as informacoes">
            <ul className="list-disc pl-5 space-y-1">
              <li>Responder ao seu atendimento e tirar duvidas sobre produtos.</li>
              <li>Avisar quando um produto voltar a ficar disponivel, caso voce solicite.</li>
              <li>
                Entender quais produtos despertam mais interesse, para melhorar o
                catalogo e o estoque.
              </li>
            </ul>
          </Secao>

          <Secao titulo="4. Compartilhamento de dados">
            <p>
              <strong>Nao vendemos nem alugamos</strong> seus dados pessoais. O
              atendimento e feito pelo WhatsApp, aplicativo operado pela Meta — ao falar
              conosco por esse canal, a comunicacao tambem fica sujeita a politica de
              privacidade da Meta.
            </p>
            <p>
              Podemos compartilhar informacoes quando exigido por lei ou por autoridade
              competente.
            </p>
          </Secao>

          <Secao titulo="5. Cookies e medicao de audiencia">
            <p>
              O site pode utilizar cookies e ferramentas de analise para gerar
              estatisticas de acesso de forma agregada. Voce pode bloquear ou apagar
              cookies nas configuracoes do seu navegador, sem prejuizo a navegacao no
              catalogo.
            </p>
          </Secao>

          <Secao titulo="6. Seus direitos">
            <p>
              Conforme a LGPD, voce pode, a qualquer momento, solicitar a confirmacao
              do tratamento, o acesso, a correcao, a exclusao dos seus dados ou a
              revogacao do consentimento. Para exercer esses direitos, entre em contato
              pelo e-mail{' '}
              <a
                href="mailto:atendimento@fiodecobre.com.br"
                className="font-medium"
                style={{ color: '#b45309' }}
              >
                atendimento@fiodecobre.com.br
              </a>
              .
            </p>
          </Secao>

          <Secao titulo="7. Seguranca e prazo de guarda">
            <p>
              Adotamos medidas razoaveis para proteger as informacoes que recebemos e as
              mantemos apenas pelo tempo necessario ao atendimento e ao cumprimento de
              obrigacoes legais.
            </p>
          </Secao>

          <Secao titulo="8. Alteracoes desta politica">
            <p>
              Esta politica pode ser atualizada a qualquer momento. A data da ultima
              revisao fica sempre indicada no topo desta pagina.
            </p>
          </Secao>
        </div>
      </main>

      <RodapeCatalogo />
    </div>
  );
}
